import * as L from 'leaflet';


const Partner = L.FeatureGroup.extend({
  onAdd: function () {
    const myIcon = L.divIcon({
      iconSize: [32, 32],
      className: "icon-snowhow_base_border partner"
    });
    fetch("/sh/partner/geo")
      .then((d) => d.json())
      .then((data) => {
        for (let i = 0; i < data.length; i++) {
          const l = new L.GeoJSON(data[i].loc, {
            onEachFeature: function (feature, layer) {
              layer.setIcon(myIcon);
            },
          });
          this.addLayer(l);
        }
      });
  },
});

export default Partner;
